// Single source of truth for the user-facing error copy shared by every error
// surface (EntityErrorState, ErrorBoundary) so the wording cannot drift.
export const ERROR_STATE_TITLE = 'An error happened';
export const ERROR_STATE_HINT = 'Please try again or contact our support if the error persists.';
